<template>
    <div class="app-content">
		<transition name="el-fade-in-linear">
	    	<div v-show="promptShow" class="back">
	    		<div v-show="promptShow" class="copyLink">
	    			<h1>提示</h1>
	    			<p>{{ promptContent }}</p>
	    			<button v-if="promptValue == 'copy'" @click="copyLink">复 制</button>
					<button v-else @click="promptShow = false">确 定</button>
	    		</div>
	    	</div>
	    </transition>
		<div class="center">
			<!-- <h1>临床思维训练</h1>
			<h2>致力于为医学领域专业用户提供全方面的知识与服务</h2> -->
			<span @click="download"></span>
		</div>
		<div class="zhezhao" v-if="dialog">
          <img src="../../assets/images/zhezhao.png" alt="">
        </div>
    </div>
</template>
<script>
import store from '@/store'
  export default{
    name:"transfer",
    data(){
        return{
            promptShow: false,
			promptValue: '',
			promptContent: '',
			timer:null,
			dialog: false
        }
    },
    created(){
		store.dispatch('settings/setTitle', '圣云医教云平台')
		let ua = navigator.userAgent.toLowerCase();
		if (ua.match(/MicroMessenger/i) == "micromessenger") {
			// this.ejectPrompt('copy')
			this.dialog = true
		} else {
			this.closeWeb()
		}
    },
	// mounted(){
	// 	const timer = setTimeout(() => {
	// 		console.log('11111');
	// 		// this.download();
	// 		alert('提示')
	// 	}, 3000);
	// 	document.addEventListener("visibilitychange", visibilitychange, false);
	// 	document.addEventListener("webkitvisibilitychange", visibilitychange, false);
	// 	window.addEventListener("pagehide",function() {
	// 		clearTimeout(timer);
	// 	},
	// 	false
	// 	)
	// 	function visibilitychange() {
	// 		const tag = document.hidden || document.webkitHidden;
	// 		tag && clearTimeout(timer);
	// 	}
	// },

    methods:{
		ejectPrompt(val,content){
			if (val == 'copy') {
				this.promptContent = '请复制链接地址，去外部浏览器中打开'
			    this.promptShow = true
			    this.promptValue = val
			} else {
				this.promptContent = content
				this.promptShow = true
			    this.promptValue = val
			}
		},

		copyLink(){
			let copyInput = document.createElement("input"); // 创建元素
	        // 这边为链接地址
	        copyInput.value = 'https://www.syyxcloud.com/#/download';
	        document.body.appendChild(copyInput); // 添加元素
	        copyInput.select();
	        document.execCommand("Copy"); // 执行浏览器复制命令
            document.body.removeChild(copyInput); // 移除刚创建的元素
	        this.$message.success("复制成功");
			this.promptShow = false
		},

		download() {
			let ua = navigator.userAgent.toLowerCase();
		    if (ua.match(/MicroMessenger/i) == "micromessenger") {
				this.ejectPrompt('copy')
		    } else { 
		    	if (this.judgeClient()=='Android') {
				  window.location.href = this.getPhoneType()
			    } else if (this.judgeClient()=='IOS') {
			    	window.location.href = 'https://apps.apple.com/us/app/临床训练营/id6449174548'
					// this.ejectPrompt('prompt','暂未上架苹果商店，敬请期待')
			    } else {
    
			    }
		    }
		},

		//判断手机型号
		getPhoneType(){
          let userAgent = navigator.userAgent;
          let brand = 'unknown';
          let href = 'https://sj.qq.com/appdetail/com.yddmi.yddclinic'//应用宝地址
          // let href = 'oppomarket://details?packagename=com.yddmi.doctor'//应用宝地址
          if(/iPhone|iPad/i.test(userAgent)){
            brand = 'Apple'
            href = 'https://apps.apple.com/us/app/临床训练营/id6449174548'
          }else if(/HUAWEI/i.test(userAgent)){
            brand = 'HUAWEI'
            href = 'appmarket://details?id=com.yddmi.yddclinic'
          }else if(/honor/i.test(userAgent)){
            brand = 'honor'
            href = 'appmarket://details?id=com.yddmi.yddclinic'
          }else if(/Xiaomi/i.test(userAgent)){
            brand = 'Xiaomi';
            href = 'mimarket://details?id=com.yddmi.yddclinic'
          }else if(/SamSung/i.test(userAgent)){
            brand = 'SamSung'
            href = 'samsungapps://ProductDetail/com.yddmi.yddclinic'
          }else if(/vivo/i.test(userAgent)){
            brand = 'vivo'
            href = 'vivomarket://details?id=com.yddmi.yddclinic'
          }else if(/HeyTapBrowser/i.test(userAgent)){
            brand = 'oppo'
            href = 'oppomarket://details?packagename=com.yddmi.yddclinic'
          }
          return href
        },

		closeWeb() {
			// alert(this.judgeClient())
            if (this.judgeClient()=='Android') {
				this.closeWebAndroid()
			} else if (this.judgeClient()=='IOS') {
				this.closeWebIOS()
			} else {

			}
        },

        closeWebAndroid() {
			window.location.href = 'openapp://syyxcloud.com'
        },

        closeWebIOS() {
            window.location.href = 'ydd9527://'
        },
		
		judgeClient() {
          let u = navigator.userAgent;
          let isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1;   //判断是否是 android终端
          let isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);  //判断是否是 iOS终端
          if(isAndroid){
            return 'Android';
          }else if(isIOS){
            return 'IOS';
          } else{
            return 'PC';
          }
        },
    }
}
</script>
<style lang="scss" scoped>
.app-content {
	width: 100%;
	height: 100%;
	position: relative;
	text-align: center;

	.back {
		position:absolute;
        left:0;
        top:0;
        width:100%;
        height:100%;
        background: rgba(0,14,14,0.5);
		z-index: 9;
		display: flex;
		align-items: center;
		justify-content: center;
        backdrop-filter: blur(.0267rem);
		.copyLink {
	    	width: 80%;
	    	background-color: #fff;
	    	border-radius: .16rem;
			h1 {
				font-size: .8rem;
				font-weight: 500;
				margin-top: 5%;
				color: #545454;
				padding: 0 5% 0 5%;
				text-align: center;
			}
			p {
				font-size: .6933rem;
				margin-top: 5%;
				color: #b2b2b2;
				padding: 0 5% 0 5%;
				text-align: center;
			}
			button {
				width: 100%;
				height: 15%;
				margin-top: 8%;
				border: 0;
				border-top: 1px solid #efefef;
				border-radius: 0px;
				background-color: #fff;
				font-size: .7467rem;
				font-weight: 600;
				color: #4ec39f;
				border-radius: 0 0 6px 6px;
				padding: 8px 0;
			}
	    }
	}

	.center {
		width: 10rem;
		height: 20.48rem;
		background: url('../../assets/images/clinicalDownloadBack.png') no-repeat;
        background-size: 100% 100%;

		span {
			width: 100%;
			height: 1.8667rem;
			background-color: #ad5a5a65;
			position: fixed;
			bottom: .8rem;
			left: 0rem;
			background: url('../../assets/images/clinicalDownloadButton.png') no-repeat;
            background-size: 100% 100%;
		}
	}

	// .logo {
	// 	width: 100%;
	// 	display: flex;
	// 	justify-content: center;
	// 	img {
	// 		width: 20%;
	// 		height: 20%;
	// 	}
	// }
	// .center {
	// 	width: 100%;
	// 	height: 60%;
	// 	background: url('../../assets/images/clinicalDownloadBack.png');
	// 	background-size: 100%;
	// 	h1 {
	// 		font-size: .9067rem;
    //         font-family: PingFangSC-Medium, PingFangSC-Medium;
    //         color: #121212;
	// 		font-weight: normal;
    //         letter-spacing: 6px;
	// 		text-align: center;
	// 		margin-top: 10%;
	// 	}
	// 	h2 {
	// 		font-size: .5333rem;
    //         font-family: PingFangSC-Regular, PingFangSC-Regular;
    //         font-weight: normal;
    //         color: #666666;
    //         letter-spacing: 4px;
	// 		text-align: center;
	// 		margin-top: 5%;
	// 		padding: 0 10%;
	// 	}
	// 	button {
	//     	width: 70%;
	//     	height: 1.3333rem;
	// 		margin-top: 40%;
	//     	background-color: #D3241C;
	//     	border: 0px;
	//     	text-align: center;
	//     	border-radius: 6px;
	//     	font-size: .6933rem;
	//     	font-family: PingFangSC-Medium, PingFangSC-Medium;
	//     	font-weight: normal;
    //         color: #FFFFFF;
	//     }
	// } 
	.zhezhao {
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
  
      img {
        width: 10rem;
		height: 20.48rem;
      }
    }
}
</style>